export const searchDropdown =  [
	{
	  title: "Facility Name",
	  value: "cadLocationName"
	},
	{
	  title: "Organization Name",
	  value: "cadOrganizationName"
	},
	{
	  title: "Facility Type",
	  value: "cadFacilityType"
	}
	
]



// WEBPACK FOOTER //
// ./src/pages/facilities/filter/searchDropdown.js